import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useEditableSettings } from '@/hooks/useEditableSettings';
import { EditableText } from '@/components/EditableText';

const Landing = () => {
  const navigate = useNavigate();
  const { settings, isAdmin, updateField, updateLabel } = useEditableSettings();

  if (!settings) {
    return <div className="min-h-screen bg-[#FAFAFA] flex items-center justify-center"><div className="animate-pulse text-[11px] tracking-[0.3em] uppercase text-[#525252]">Loading</div></div>;
  }

  const name = settings.site_name || 'LILY YURIKA';
  const enterLabel = settings.labels?.enter_label || 'ENTER';

  const goWork = () => navigate('/work');

  if (isAdmin) {
    return (
      <div className="min-h-screen bg-[#FAFAFA] flex flex-col items-center justify-center px-6" data-testid="landing-page">
        <div className="w-full max-w-5xl text-center">
          <EditableText
            as="h1"
            value={name}
            onChange={(v) => updateField('site_name', v)}
            editable={true}
            placeholder="SITE NAME"
            className="font-serif font-light tracking-tight leading-none text-[12vw] sm:text-[10vw] md:text-[9vw] lg:text-[8vw] text-center w-full"
            testId="landing-name"
          />
          <div className="mt-10 sm:mt-14">
            <EditableText
              value={enterLabel}
              onChange={(v) => updateLabel('enter_label', v)}
              editable={true}
              placeholder="ENTER"
              className="text-[11px] tracking-[0.5em] uppercase font-semibold text-[#525252] border-b border-[#A3A3A3] pb-1 max-w-[120px] text-center"
              testId="enter-button"
            />
          </div>
          <div className="mt-12 text-[10px] tracking-[0.25em] uppercase text-[#A3A3A3]">
            Inline editing on — changes save automatically. <button onClick={goWork} className="underline ml-2 hover:text-black">Go to site →</button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div
      className="min-h-screen bg-[#FAFAFA] flex flex-col items-center justify-center cursor-pointer select-none px-6"
      onClick={goWork}
      data-testid="landing-page"
    >
      <h1
        className="font-serif font-light tracking-tight text-center leading-none text-[12vw] sm:text-[10vw] md:text-[9vw] lg:text-[8vw]"
        data-testid="landing-name"
      >
        {name}
      </h1>
      <button
        onClick={(e) => { e.stopPropagation(); goWork(); }}
        className="mt-10 sm:mt-14 text-[11px] tracking-[0.5em] uppercase font-semibold text-[#525252] hover:text-black transition-colors duration-300 border-b border-[#A3A3A3] hover:border-black pb-1"
        data-testid="enter-button"
      >
        {enterLabel}
      </button>
    </div>
  );
};

export default Landing;
